/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  settings: {
    //general
    favicon: '',
    tabName: '',
    simultaneousSessions: false,
    footer: '',
    logicalExclusion: false,
    telegramBotToken: '',
    telegramWelcomeMessage: '',
    apiDelegator: '',
    apiIntegrationToken: '',

    //login
    title: '',
    tabTitle: '',
    subtitle: '',
    usernameLabel: '',
    passwordLabel: '',
    submitButtonText: '',
    forgotLabel: '',
    logo: '',
    background: '',
    forgotPasswordTitle: '',
    resetFormTitle: '',
    forgotPasswordEmailLabel: '',
    forgotPasswordButtonLabel: '',
    cardLogo: '',

    //outGoingLabel
    emailSenderDriverTypeId: 1,
    emailSenderHost: '',
    emailSenderPort: '',
    emailSenderFromName: '',
    emailSenderFromAddress: '',
    emailSenderUsername: '',
    emailSenderPassword: ''
  }
}
